const getImageUrl = {}

getImageUrl.get = (type, id, name) => {
  if (name === undefined) return '/img/noImage.png'
  if (type === 'profile' && (name === '' || name === undefined || name === null)) return 'https://hotfood.katsulabo.com/image/user_no_image.png'
  if (type === 'profile' && name !== 'profile.png') return name

  let fname = `${type}/${id}/${name}`

  // サムネイル画像
  if (type === 'food_thumbs') {
    name = name.replace('.png', '_200x200.png')
    fname = `food/${id}/thumbs/${name}`
  }

  let encodeFname = encodeURIComponent(fname)
  let imageUrl = `https://firebasestorage.googleapis.com/v0/b/hotfood-dev-ce143.appspot.com/o/${encodeFname}?alt=media`
  // let imageUrl = `https://storage.googleapis.com/hotfood-dev-ce143.appspot.com/${fname}`
  return imageUrl
}

export default getImageUrl